export function _legalEventArray(arr = []) {
  const legals = arr.filter(obj => +obj.number > 1)
  return legals
}
